export default {
  afterSalesDeduction: {
    title: 'After-sales Deductions (Trial)',
    orderStatus: 'Order Status',
    all: 'All',
    pendingBusinessReview: 'Pending Business Review',
    pendingSettlement: 'Pending Settlement',
    completed: 'Completed',
    orderNumber: 'Order ID',
    aftersalesNumber: 'After-sales Order ID',
    skuNumber: 'SKU#',
    feeType: 'Fee Type',
    aftersalesReturnShippingFee: 'After-sales Return Shipping Fee',
    seriousViolationPenalty: 'Serious Violation Penalty',
    aftersalesRepairFee: 'After-sales Repair Fee',
    customerNumber: 'Customer ID',
    productTitle: 'Product Title',
    exportExcel: 'Export to Excel',
    creationTime: 'Creation Time',
    deductionOrderNo: 'AS Deduction ID',
    aftersalesOrderNo: 'After-sales Order ID',
    currency: 'Currency',
    amount: 'Amount',
    aftersalesMethod: 'After-sales Method',
    settlementTransactionNo: 'Settlement Transaction No.',
    createdTime: 'Creation Time',
    status: 'Status',
    settlementCompletedTime: 'Settled Time'
  },
  logisticsDeduction: {
    title: 'Logistics Deductions Order & Fees (Trial)',
    orderStatus: 'Order Status',
    all: 'All',
    pendingAudit: 'Pending Business Audit',
    pendingSettlement: 'Pending Settlement',
    settled: 'Completed',
    waybillNo: 'Waybill No.',
    productTitle: 'Product Title',
    marketplaceSku: 'SKU#',
    exportExcel: 'Export to Excel',
    creationTime: 'Creation Time',
    settlementTime: 'Settled Time',
    deductionOrderNo: 'Deduction Order ID',
    businessNo: 'Business Reference No.',
    currency: 'Currency',
    amount: 'Amount',
    type: 'Type',
    fundAccount: 'Merchant Settlement Account',
    status: 'Status',
    pendingFinanceAudit: 'Pending Finance Audit',
    pleaseSelectTime: 'Please select time'
  },
  orderCancel: {
    title: 'Fine Of Cancel (Store) (Trial)',
    orderStatus: 'Order Status',
    all: 'All',
    toBeEffective: 'To Be Effective',
    invalidated: 'Invalidated',
    deducted: 'Deducted',
    skuNumber: 'SKU#',
    listingNumber: 'Listing#',
    orderNumber: 'Order# or SN',
    exportExcel: 'Export to Excel',
    fineId: 'FineID',
    orderSn: 'OrderSN',
    currency: 'Currency',
    fineAmount: 'FineAmount',
    reasonType: 'ReasonType',
    orderTime: 'OrderTime',
    payTime: 'PayTime',
    cancelTime: 'CancelTime',
    operator: 'Operator#',
    logTime: 'LogTime',
    fineStatus: 'FineStatus'
  },
  productViolation: {
    title: 'Product Violation Fines (Trial)',
    status: 'Order Status',
    all: 'All',
    toBeEffective: 'To Be Effective',
    invalidated: 'Invalidated',
    deducted: 'Deducted',
    listingNumber: 'Listing#',
    productTitle: 'Product Title',
    exportExcel: 'Export to Excel',
    fineId: 'Fine ID',
    currency: 'Currency',
    fineAmount: 'Fine Amount',
    catId: 'Category ID',
    submitType: 'Submission Type',
    credentialNumber: 'Credential#',
    logTime: 'Log Time',
    deductionTime: 'Deduction Time',
    fineStatus: 'Fine Status'
  },
  settlementArrear: {
    title: 'Arrears Payment Order (Trial)',
    status: 'Order Status',
    all: 'All',
    pendingFinancialAudit: 'Pending Financial Audit',
    pendingSettlement: 'Pending Settlement',
    completed: 'Completed',
    selectPeriod: 'Select Period',
    arrearsOrderNo: 'Arrears Payment Order ID',
    currency: 'Currency',
    amount: 'Amount',
    settlementPeriod: 'Settlement Period',
    creationTime: 'Creation Time',
    statusLabel: 'Status',
    settledTime: 'Settled Time',
    operation: 'Operation',
    details: 'Details',
    detailTitle: 'Arrears Payment Order Details',
    fundAccount: 'Associated Settlement Account',
    arrearsAmount: 'Arrears Amount',
    generatedDetails: 'Breakdown of Charges',
    marketplaceOrderSettlement: 'Store Order Settlement',
    logisticsWarehouseFee: 'Logistics Deductions / Storage Fees',
    platformMaintenanceFee: 'Store Deductions / After-sales Refunds',
    billingPeriod: 'Billing Cycle',
    settlementStatus: 'Settlement Status',
    settlementTime: 'Settled Time',
    close: 'Close',
    pendingAudit: 'Pending Audit',
    pendingPayment: 'Pending Payment',
    paid: 'Manually Paid',
    deferredSettlement: 'Carried Forward to Next Cycle'
  },
  expressCompensation: {
    title: 'Lost/Damaged Item Compensation List (Trial)',
    orderStatus: 'Order Status',
    all: 'All',
    waybillNo: 'Waybill No.',
    skuNumber: 'SKU#',
    productTitle: 'Product Title',
    exportExcel: 'Export to Excel',
    creationTime: 'Created Time',
    settlementTime: 'Settled Time',
    pleaseSelectTime: 'Please select time',
    compensationOrderNo: 'Compensation ID',
    businessReferenceNo: 'Original Order ID',
    sku: 'SKU',
    compensationQty: 'Compensation Qty',
    currency: 'Currency',
    totalAmount: 'Total Amount',
    productCompensation: 'Product Compensation',
    commissionCompensation: 'Commission Compensation',
    fundAccount: 'Merchant Settlement Account',
    createdTime: 'Creation Time',
    status: 'Status',
    operations: 'Operations',
    details: 'Details',
    // 状态
    statusCreated: 'Pending Amount Generation',
    statusAmountGenerated: 'Pending Amount Confirmation',
    statusAmountConfirmed: 'Pending Financial Audit',
    statusApproved: 'Pending Settlement',
    statusDone: 'Completed',
    statusRefused: 'Rejected',
    // 详情弹窗
    detailTitle: 'Lost/Damaged Item Compensation Details',
    productAndStoreInfo: 'Product and Store Information:',
    skuInfo: 'SKU Info',
    waybillInfo: 'Waybill Info',
    relatedMarketplaceOrderNo: 'Associated Order No.',
    belongingStore: 'Store Name',
    lossConfirmationTime: 'Loss Confirmation At',
    compensationOrderGenerationTime: 'Claim Created At',
    transactionUnitPrice: 'Unit Price',
    compensationQtyLabel: 'Quantity Compensated',
    compensationOrderStatus: 'Claim Status',
    compensationAmount: 'Compensation Amount',
    compensationAmountLabel: 'Total Compensation',
    commissionDeduction: 'Commission Deduction',
    actualProductCompensation: 'Actual Payout',
    compensationOrderStatusLabel: 'Claim Status:',
    verifiedQty: 'Verified Qty',
    verifiedAmount: 'Verified Amount',
    verificationTime: 'Verification Time',
    businessAuditTime: 'Business Audit Time',
    financialAuditTime: 'Financial Audit Time',
    settlementTimeLabel: 'Settlement Time',
    rejectionReason: 'Rejection Reason',
    close: 'Close'
  },
  settlementBillDocuments: {
    title: 'Settlement Bills (Trial)',
    displayMode: 'Display Mode',
    viewByBusinessUnit: 'View by Business Segment',
    aggregateView: 'Consolidated View',
    selectSettlementPeriod: 'Settlement Period',
    selectBillType: 'Select Bill Type',
    selectSettlementStatus: 'Select Settlement Status',
    selectStatementDateRange: 'Select Statement Date Range',
    billingReference: 'Billing Reference',
    settlementPeriod: 'Settlement Period',
    currency: 'Currency',
    billAmount: 'Bill Amount',
    billType: 'Bill Type',
    marketplaceOrderSettlement: 'Marketplace Order Settlement',
    marketplaceFeesAftersales: 'Marketplace Fees & After-sales',
    logisticsWarehouseFees: 'Logistics & Warehousing Fees',
    settlementAccount: 'Settlement Account',
    occurrenceTime: 'Occurrence Time',
    status: 'Status',
    settlementStatus: 'Settlement Status',
    settled: 'Settled',
    billingInProgress: 'Billing In Progress',
    pendingConfirmation: 'Pending Confirmation',
    pendingSettlement: 'Pending Settlement',
    periodDuration: 'Period Duration',
    billingDuration: 'Billing Duration',
    actions: 'Actions',
    expand: 'Expand',
    download: 'Download',
    feeDetails: 'Fee Details'
  },
  repairCost: {
    title: 'Repair Cost (Trial)',
    skuNumber: 'SKU No.',
    periodType: 'Period Type',
    weekly: 'Weekly',
    monthly: 'Monthly',
    periodCode: 'Period',
    importTime: 'Import Time',
    startDate: 'Start Date',
    endDate: 'End Date',
    search: 'Search',
    reset: 'Reset',
    feeId: 'Fee ID',
    repairStatus: 'Repair Status',
    productType: 'Product Type',
    brand: 'Brand',
    productModel: 'Product Model',
    shopId: 'Shop ID',
    shopName: 'Shop Name',
    skuNo: 'SKU No.',
    skuPrice: 'SKU Price',
    quantity: 'Quantity',
    priceQuotation: 'Price Quotation',
    remark: 'Remark',
    applyTime: 'Apply Time',
    periodCodeLabel: 'Period',
    operator: 'Operator',
    effectiveTime: 'Effective Time'
  },
  billingBreakdown: {
    title: 'Billing Details',
    selectSettlementPeriod: 'Settlement Period',
    selectBillType: 'Select Bill Type',
    startDate: 'Start Date',
    endDate: 'End Date',
    referenceId: 'Reference ID',
    objectId: 'Object ID',
    export: 'Export',
    feeId: 'Fee ID',
    subject: 'Subject',
    feeItem: 'Fee Item',
    postingDate: 'Posting Date',
    currency: 'Currency',
    direction: 'Direction',
    transactionAmount: 'Transaction Amount',
    site: 'Site',
    referenceType: 'Reference Type',
    objectType: 'Object Type',
    unitPrice: 'Unit Price',
    qty: 'Qty',
    keyParams: 'Key Parameters',
    billingPeriod: 'Billing Cycle / Period',
    pleaseSelectPeriod: 'Please select a billing period',
    exportGenerating: 'Generating export file, please wait…',
    exportTimeout: 'Export timed out, please try again later.',
    exportMissingParams: 'Merchant bill number or bill type is missing; export cannot be submitted.'
  },
  settlementEntity: {
    title: 'Settlement Entity and Information',
    selectTip: 'Select a settlement entity (company) for the current merchant',
    companyName: 'Company Name',
    registrationNo: 'Company Registration No.',
    legalPersonName: 'Legal Representative',
    companyLocation: 'Company Location',
    confirmApply: 'Apply',
    changePendingTip: 'This entity has a pending settlement card change and cannot be selected',
    modificationPending: 'A settlement‑information modification request is currently in‑progress. To prevent operation conflicts, you cannot select a settlement entity here for the time‑being.',
    applyConfirm: 'The unique settlement entity can only be selected once. Are you sure you want to continue?',
    confirmTitle: 'Confirmation',
    confirm: 'Confirm',
    cancel: 'Cancel'
  }
}
